import React, { useContext, useEffect, useCallback } from 'react'
import { navigate } from 'gatsby'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import SignInUpModal from 'components/modal/submodals/SignInUpModal'
import RewardsModal from './submodals/RewardsModal'
import UserImageModal from './submodals/UserImageModal'
import SpinModal from './submodals/SpinModal'
import ChangeFunFactModal from './submodals/ChangeFunFactModal'
import ChangePasswordModal from './submodals/ChangePasswordModal'
import DeleteAccountModal from './submodals/DeleteAccountModal'
import ForgotPasswordModal from './submodals/ForgotPasswordModal'
import CopyLinkModal from './submodals/CopyLinkModal'
import CompleteProfileModal from './submodals/CompleteProfileModal'

import BreakLimitModal from './submodals/BreakLimitModal'
import BreakConversionModal from './submodals/BreakConversionModal'

import './Modal.scss'

const Modal = () => {
  const modal_context = useContext(modalContext)
  const {
    modalStatus,
    modalContent,
    setModalContent,
    toggleModal,
    showSignUpModalTab,
  } = modal_context || {}

  const closeModal = e => {
    setModalContent(undefined)
    toggleModal(undefined)
  }

  const handleSignUpClick = () => {
    //navigate("/")
    toggleModal(undefined)
    showSignUpModalTab()
  }

  const handleHowItWorksClick = () => {
    navigate('/how-it-works')
    toggleModal('off')
  }

  const escFunction = useCallback(event => {
    if (event.keyCode === 27) {
      closeModal()
    }
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)
  }, [])

  const needsExternalClose =
    modalContent &&
    [
      'userimage',
      'changefunfact',
      'deleteaccount',
      'changepw',
      'generic',
    ].includes(modalContent.type)

  return (
    <>
      {modal_context && (
        <>
          <div className="modal-elements">
            <div
              className={`modal-full-screen-overlay ${modalStatus}`}
              onClick={closeModal}
            ></div>
            <div className={`modal ${modalStatus || ''}`}>
              <div className="modal-container">
                {/* note: we should refactor this to apply a shorter array assignment-to-import or something */}
                {modalContent && modalContent.type === 'signinup' && (
                  <SignInUpModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'sponsoredform' && (
                  <SignInUpModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'userimage' && (
                  <UserImageModal />
                )}
                {modalContent && modalContent.type === 'changefunfact' && (
                  <ChangeFunFactModal />
                )}
                {modalContent && modalContent.type === 'deleteaccount' && (
                  <DeleteAccountModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'rewards' && (
                  <RewardsModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'spin' && (
                  <SpinModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'forgotpw' && (
                  <ForgotPasswordModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'changepw' && (
                  <ChangePasswordModal />
                )}
                {modalContent && modalContent.type === 'completeprofile' && (
                  <CompleteProfileModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'breaklimit' && (
                  <BreakLimitModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'breakconversion' && (
                  <BreakConversionModal
                    closeModal={closeModal}
                    onSignUpClick={handleSignUpClick}
                    onHowItWorksClick={handleHowItWorksClick}
                  />
                )}
                {modalContent && modalContent.type === 'copylinkmodal' && (
                  <CopyLinkModal closeModal={closeModal} />
                )}
                {modalContent && modalContent.type === 'generic' && (
                  <div className="modal-generic">
                    <div className="modal-header">
                      <span className="modal-header-generic">
                        {modalContent.title}
                      </span>
                    </div>
                    <div className="content-body">
                      <p>{modalContent.description}</p>
                    </div>
                  </div>
                )}
              </div>

              {/* some modals include their own close buttons, others don't */}
              {needsExternalClose && (
                <button
                  className={`modal-close${
                    modalContent && modalContent.type
                      ? ` ${modalContent.type}`
                      : ''
                  } top-level-close`}
                  onClick={closeModal}
                  aria-label="Close"
                ></button>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Modal
